module.exports = __webpack_public_path__ + "img/Metastasis-BRCA_GSE176078.ee605d9a.png";